import React from "react";
import Carousel from './Carousel/Carousel'
export const Testimonials = (props) => {
  return (
    <div id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <h2>Отзывы</h2>
        </div>
        <Carousel value={props.data}/>
        {/*<div className="row">
          {props.data
            ? props.data.map((d, i) => (              
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <div className="testimonial">
                    <div className="testimonial-image">
                      {" "}
                      {d.type ==='pdf'?<embed src={d.img} width="358px" height="508px" type="application/pdf"/>: <img src={d.img} alt={d.type}/>}
                        
                      {" "}
                    </div>
                    <div className="testimonial-content">
                      <p>"{d.text}"</p>
                      <div className="testimonial-meta"> - {d.name} </div>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>*/}
      </div>
    </div>
  );
};
